import { render, staticRenderFns } from "./ColorSpanTutorial.vue?vue&type=template&id=f222d014&scoped=true&"
import script from "./ColorSpanTutorial.vue?vue&type=script&lang=js&"
export * from "./ColorSpanTutorial.vue?vue&type=script&lang=js&"
import style0 from "./ColorSpanTutorial.vue?vue&type=style&index=0&id=f222d014&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f222d014",
  null
  
)

export default component.exports